import type { AxiosResponse } from 'axios';

type EventCallback<T> = (data: T) => void;

export type AxiosEventMap = {
  response: AxiosResponse<unknown, unknown>;
  responseError: unknown;
};

export class AxiosEventBus {
  public listeners: Record<keyof AxiosEventMap, Array<EventCallback<any>>>;

  constructor() {
    this.listeners = {
      response: [],
      responseError: [],
    };
  }

  subscribe = <K extends keyof AxiosEventMap>(
    eventName: K,
    callback: EventCallback<AxiosEventMap[K]>,
  ): void => {
    this.listeners[eventName].push(callback);
  };

  unsubscribe = <K extends keyof AxiosEventMap>(
    eventName: K,
    callback: EventCallback<AxiosEventMap[K]>,
  ): void => {
    this.listeners[eventName] = this.listeners[eventName].filter(
      (listener) => listener !== callback,
    );
  };

  emit = <K extends keyof AxiosEventMap>(eventName: K, data: AxiosEventMap[K]): void => {
    this.listeners[eventName].forEach((callback) => callback(data));
  };
}
